import { useEffect, useState } from 'react';
import { onAuthStateChanged, signInAnonymously } from 'firebase/auth';
import { auth } from '../services/auth';

// Tracks the current Firebase Auth user, signing in anonymously on first
// mount if nobody's signed in yet. Reactive, so it also picks up the
// upgrade from anonymous to a linked Google account automatically.
export function useAuthUser() {
  const [user, setUser] = useState(() => auth.currentUser);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, setUser);
    if (!auth.currentUser) {
      signInAnonymously(auth).catch(console.error);
    }
    return unsubscribe;
  }, []);

  return user;
}
